import themes from '../styles/themes';
import hasOwnProperty from './hasOwnProperty';

/**
 * Returns the color of the text that goes with the theme colour provided.
 */
const getThemeTextColor = (color: string): string => {
  if (!hasOwnProperty(themes, color)) {
    console.warn(
      `getThemeTextColor() could not find ${color} in theme, reverting to white text`,
    );
    return 'white--text';
  }
  return themes[color].darkHeader ? 'white--text' : 's-text--dark';
};

export default getThemeTextColor;
